import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ShippingService } from '../../services/api-services/shipping.service';
import { FormService } from '../../services/form.service';
import { HelperService } from '../../services/helper.service';
import { numericAlpha, spaceValidator } from '../../validator/form-validators.service';
import { ValidationMessagesService } from '../../validator/validation-messages.service';

@Component({
  selector: 'app-add-delivery-partner',
  templateUrl: './add-delivery-partner.component.html',
  styleUrls: ['./add-delivery-partner.component.scss']
})
export class AddDeliveryPartnerComponent {

  form: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  constructor(public dialogRef: MatDialogRef<AddDeliveryPartnerComponent>,
    private fb: FormBuilder,
    public toast: ToastrService,
    public shippingService: ShippingService,
    public formService: FormService,
    public validationMessagesService: ValidationMessagesService,
    public helperService: HelperService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any) {
    this.initializeForm();
  }
  initializeForm() {
    this.form = this.fb.group({
      deliveryPartnerName: new FormControl("", Validators.compose([Validators.required, spaceValidator, numericAlpha])),
    });
  }
  formSubmit() {
    if (this.form.valid) {
      let obj = {
        name: this.form.value.deliveryPartnerName,
      }
      this.isLoading = true;
      this.shippingService.create_delivery_partner(obj).subscribe(res => {
        this.isLoading = false;
        if (res.body.success) {
          this.props.deliveryPartners.push(res.body.data);
          this.toast.success(res.body.message[0]);
          this.formService.addDeliveryPartner.setValue(res.body.data.id);
          this.dialogRef.close();
        }
        else {
          this.toast.error(res.body.message[0]);
        }
      })
    }
    else {
      this.validationMessagesService.validateAllFormFields(this.form);
    }
  }
}
